import { render, staticRenderFns } from "./BranchTimeAdd.vue?vue&type=template&id=ea37d048&scoped=true&"
import script from "./BranchTimeAdd.vue?vue&type=script&lang=js&"
export * from "./BranchTimeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea37d048",
  null
  
)

export default component.exports